import { render, staticRenderFns } from "./studentStoryVideoInfo.vue?vue&type=template&id=38da94c8"
import script from "./studentStoryVideoInfo.vue?vue&type=script&lang=js"
export * from "./studentStoryVideoInfo.vue?vue&type=script&lang=js"
import style0 from "./studentStoryVideoInfo.vue?vue&type=style&index=0&id=38da94c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports